import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";

// ✅ Get Goal category
export const GetGoalTypeHelper = async () => {
  return await axiosInstance(`/pms/Setting/getGoalType`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
    },
  })
    .then((res) => {
      return {
        message: "Goal category retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return {
        message: "Unable to retrieve goal category",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Add Goal category
export const AddGoalTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/pms/Setting/addGoalType`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      goal_category: params?.goal_category,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal category added successfully");
      return {
        message: "Goal category added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add goal category",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Update Goal category
export const UpdateGoalTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Updating...");
  return await axiosInstance(`/pms/Setting/updateGoalType`, {
    method: "PUT",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      goal_category_config_pk: params?.goal_category_config_pk,
      goal_category: params?.goal_category,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal category updated successfully");
      return {
        message: "Goal category updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update goal category",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Delete Goal category
export const DeleteGoalTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/pms/Setting/deleteGoalType`, {
    method: "DELETE",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      goal_category_config_pk: params?.goal_category_config_pk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal category deleted successfully");
      return {
        message: "Goal category deleted successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to delete goal category",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Get Goal Subtypes
export const GetGoalSubtypeHelper = async (params) => {
  return await axiosInstance(`/pms/Setting/getGoalSubtype`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      goal_category_id: params?.goal_category_id || null
    },
  })
    .then((res) => {
      return {
        message: "Goal subtypes retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return {
        message: "Unable to retrieve goal subtypes",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Add Goal Subtype
export const AddGoalSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/pms/Setting/addGoalSubtype`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      goal_subcategory: params?.goal_subcategory,
      goal_category_id: params?.goal_category_configuration_pk?.goal_category_configuration_pk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal added successfully");
      return {
        message: "Goal added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add goal subtype",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Update Goal Subtype
export const UpdateGoalSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/pms/Setting/updateGoalSubtype`, {
    method: "PUT",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      goal_subcategory_config_id: params?.goal_sub_category_configuration_pk,
      goal_subcategory_name: params?.goal_subcategory,
      goal_category_config_id: params?.goal_category_fk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal updated successfully");
      return {
        message: "Goal updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update goal subtype",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ✅ Delete Goal Subtype
export const DeleteGoalSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/pms/Setting/deleteGoalSubtype`, {
    method: "DELETE",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      goal_subcategory_config_id: params?.goal_subcategory_config_id,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Goal deleted successfully");
      return {
        message: "Goal deleted successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to delete goal subtype",
        hasError: true,
        data: err?.response?.data,
      };
    });
};
